import { exportGLB } from "./exportGLB";

export async function handleARProcess({
    modelRef,
    setLoading,
    setArUrls,
    setIsExporting,
    params
}) {
    try {
        setLoading(true);
        // 1. GLB dosyasını export et
        modelRef.current.updateMatrixWorld(true);
        const raw = await exportGLB(modelRef.current);
        const blob = new Blob([raw], { type: "model/gltf-binary" });

        // 2. FormData oluştur
        const formData = new FormData();
        formData.append("file", blob, "model.gltf");

        const userAgent = navigator.userAgent || "";
        const isIOS = /iPad|iPhone|iPod/.test(userAgent);
        const isAndroid = /Android/.test(userAgent);
        const versionMatch = userAgent.match(/(OS|Android) (\d+[_\.]?\d*)/);
        const version = versionMatch ? versionMatch[2].replace("_", ".") : "unknown";

        if (isIOS && (isNaN(version) || version < 12)) {
            alert("Bu cihazda AR özelliği desteklenmiyor. iOS 12 ve üzeri gereklidir.");
            return;
        }
        if (isAndroid && version < 10) {
            alert("Bu cihazda AR özelliği desteklenmiyor. Android 10 ve üzeri önerilir.");
            return;
        }

        formData.append("device_type", isIOS ? "ios" : isAndroid ? "android" : "unknown");
        formData.append("version", version);
        formData.append("project_item_id", params.id);

        let url = `https://api.albertgenauapp.com/projectitem/upload3D`;

        const response = await fetch(url, {
            method: "POST",
            body: formData,
            headers: {
                "Auth-Key": params.key,
                "Client-Service": params.service,
            },
        });

        if (!response.ok) throw new Error("Upload başarısız");

        const data = await response.json();

        if (data.status.code == 200) {
            const result = data.result;

            if (!result.glb_url || !result.usdz_url) {
                throw new Error("Geçersiz yanıt");
            }

            // 3. AR URL’lerini güncelle
            setArUrls({ glb: result.glb_url, usdz: result.usdz_url });

            setTimeout(() => {
                document.querySelector("model-viewer")?.activateAR?.();
            }, 300); // kısa gecikme animasyon yüklenmesi için güvenlidir
        } else {
            throw new Error("Upload başarısız");
        }
    } catch (err) {
        alert("AR yükleme hatası: " + err.message);
    } finally {
        setLoading(false);
    }
}
